'use strict';

const ajax = require('../../modules/ajax'),
    stickyAddToCart = require('./stickyaddtocart'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    appendParamsToUrl = require('../../modules/util/appendParamsToUrl'),
    getQueryStringParams = require('../../modules/util/getQueryStringParams'),
    getQueryString = require('../../modules/util/getQueryString'),
    gtm = require('../../modules/google').tagManager,
    outOfStock = require('./outOfStock');


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 * @param {String} forcePdpUpdate - instead of looking for the closest pdp content, updates the main one
 * @param {Boolean} isProductTile - changes the update target class to the product-tile one
 **/
const updateContent = function (href, target, forcePdpUpdate, isProductTile) {

    // get target class to update
    const targetClass = isProductTile ? '.js-product-tile' : '.js-product-details-content';
    // get closest .js-product-details-content in case there are several in a page (like recommendations product quickview in a PDP)
    const $updateTarget = forcePdpUpdate ? $('.js-product-details-content') : $(target).closest(targetClass);

    // if there is a hidden field with the source, pass it along with the params
    let source = '';
    const sourceEl = $(target).closest('.js-product-tile').find('.js-include-source');
    if (sourceEl.length){
        source = sourceEl.text();
    }

    let $pdpForm = $('.js-pdp-add-to-cart-form');
    const qty = $pdpForm.find('input[name="Quantity"]').first().val();
    const params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        source: source,
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    progress.show($('.js-pdp-main'));

    ajax.load({
        url: appendParamsToUrl(href, params),
        target: $updateTarget,
        replaceTarget: isProductTile,
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }

            // update gtm datalayer
            // could be done better by getting the variant values from the
            // response
            $pdpForm = $('.js-pdp-add-to-cart-form');
            const availability = $pdpForm.find('input[name="availableQuantity"]').first().val();
            const variantId = $pdpForm.find('input[name="pid"]').val();
            const qsParams = getQueryStringParams(getQueryString(href));
            const masterId = qsParams.pid;
            if ((masterId !== variantId) && (typeof availability !== 'undefined')){
                gtm.selectVariant('products', masterId, variantId, availability);
            }

            // reinit sticky add to cart
            stickyAddToCart.init();

            // reset the "back in stock" form
            outOfStock.resetForm(variantId);
        }
    });
};

/**
 * @description flyout size selection bar is loading before the pdp page.
 * And flyout is not updating with size selection on pdp, should be updated manually.
 * @param {String} clickedSize - text of the clicked size
 * @param {Boolean} enableDeselect - If true, the customer can deselect a size
 **/
const updateFlyoutVariations = function (clickedSize, enableDeselect) {
    $('.js-swatch-anchor').each(function() {
        if (this.innerText === clickedSize && !($(this).parent('li').hasClass('selected'))) {
            $(this).parent('li').addClass('selected');
        } else if (this.innerText !== clickedSize || enableDeselect) {
            $(this).parent('li').removeClass('selected');
        }
    });
};

/**
 * @description handle variation click
 **/
function variationChangeHandler(e, forcePdpUpdate){
    const target = e.target;

    // if not selectable, do nothing
    if ($(target).hasClass('js-swatch-unselectable')) { return; }

    // //update size selection bar on flyout
    updateFlyoutVariations(target.innerText, true);

    let href;
    let isProductTile = false;

    // if target parent is a product tile, href gets product tile
    // TODO: have this product tile href logic come from the variations.isml
    if ($(target).parents('.js-product-tile').length > 0){

        // if product tile and out of stock, do not select
        if ($(target).parent().hasClass('js-swatch-out-of-stock')) {
            return;
        }

        // get product id from the variation
        const pid = $(target).data('pid');

        const showimage = $(target).closest('.js-grid-wrap').length > 0 ? true : false;

        const params = {
            'pid': pid,
            'showimage': showimage
        };
        href = appendParamsToUrl(Urls.getProductTile, params);
        isProductTile = true;
    } else {
        href = target.href || $(target).find('option:selected').data('href');
    }

    // update content
    updateContent(href, target, forcePdpUpdate, isProductTile);

    const isSelected = $(target).parent('.swatch').hasClass('selected');

    // update add to cart btn in sticky bar
    stickyAddToCart.updateAddToCartBtn(target, isSelected);
}

function cartVariationChangeHandler(e) {
    const $target = $(e.target);

    // if not selectable, do nothing
    if ($target.hasClass('js-swatch-unselectable')) { return; }

    // //update size selection
    updateFlyoutVariations($target[0].innerText, false);

    //Update the product id to send
    const productId = $target.data('pid');
    const pidInputField = $target.closest('.js-cart-product-variation-edit').find('.js-product-variation-edit-product-id');
    pidInputField.val(productId);
}

function initEvents(){
    // click on swatch - should replace product content with new variant
    $('body').on('click', '.js-swatch-anchor-variant', function(e) {
        e.preventDefault();
        e.stopPropagation();
        variationChangeHandler(e);
    });

    //Cart swatch click - different logic than other pages
    $('body').on('click', '.js-cart-swatch-anchor-variant', function(e) {
        e.preventDefault();
        e.stopPropagation();
        cartVariationChangeHandler(e);
    });

    $('body').on('change', '.js-variations-dropdown', function(e){
        variationChangeHandler(e, true);
    });
}

module.exports = function () {
    initEvents();
};
